import { render, staticRenderFns } from "./DemonstrativoNotasFrequencia.vue?vue&type=template&id=5064e274&"
import script from "./DemonstrativoNotasFrequencia.vue?vue&type=script&lang=js&"
export * from "./DemonstrativoNotasFrequencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports